<template lang="html">
  <div>
    <v-card>
      <v-card-title>{{ $t("forms.title") }}</v-card-title>
      <v-card-text>
        <v-list>
          <v-list-item-group>
            <v-row no-gutters>
              <v-col
                v-for="(form, index) in forms"
                :key="index"
                cols="12"
                md="6"
                lg="4"
              >
                <v-list-item
                  :to="'/stays/' + stay.id + form.path"
                  class="text-left"
                >
                  <v-list-item-icon>
                    <v-icon v-text="form.icon"></v-icon>
                  </v-list-item-icon>
                  {{ $t(form.title) }}
                </v-list-item>
              </v-col>
            </v-row>
          </v-list-item-group>
        </v-list>
      </v-card-text>
    </v-card>

    <v-card class="mt-4 pa-6">

      <row-col-select-one-field
          v-model="stay.person"
          data-source="person"
          :label="$t('form.person_stay')"
          :readonly="true"
        />

      <v-row>
        <col-date-field
          v-model="stay.start_date"
          :label="$t('form.date_start')"
          :readonly="true"
        />
        <col-date-field 
          v-model="stay.end_date"
          :label="$t('form.date_end')"
          :readonly="true"
        />
      </v-row>

      <row-col-radio-horizontal-field
          v-model="stay.type"
          :label="$t('form.stay_type')"
          :options="[
            { text: $t('form.stay_predoc'), value: 'predoc' },
            { text: $t('form.stay_posdoc'), value: 'posdoc' },
            { text: $t('form.stay_other'), value: 'other' }
          ]"
          :readonly="true"
        />

      <row-col-select-one-field
        v-model="stay.organization"
        data-source="organization"
        :label="$t('form.organization_stay')"
        :readonly="true"
        :allow-custom-value="true"
      />

      <row-col-text-field
        v-model="stay.responsible"
        :label="$t('form.responsible')"
        :readonly="true"
      />

      <row-col-text-area-field
        v-model="stay.description"
        :label="$t('form.description_stay')"
        :readonly="true"
      />

      <row-col-select-one-field
        v-model="stay.funder_program"
        data-source="funder_program"
        :label="$t('form.funder_program_stay')"
        :readonly="true"
      />

      <row-col-text-area-field
        v-model="stay.funding_comments"
        :label="$t('form.funding_comments')"
        :readonly="true"
      />

      <v-row>
        <v-col class="text-center mt-6">
          <v-btn
            type="submit"
            class="btn-large-space btn-danger mr-4"
            text
            v-on:click="$router.go(-1)"
            >{{ $t("button.back") }}</v-btn
          >
          <DeleteReasonBtn
            url-objects="stay"
            object_type="stay"
            :headers="headers"
            :item="stay"
          />
        </v-col>
      </v-row>
    </v-card>

    <div class="mt-6 text-center"></div>
  </div>
</template>

<script type="text/javascript">
import DeleteReasonBtn from "../delete_object/DeleteObjectForm";
import RowColTextAreaField from "@/components/reusables/RowColTextAreaField.vue";
import ColDateField from "@/components/reusables/ColDateField.vue";
import RowColSelectOneField from "@/components/reusables/RowColSelectOneField.vue";
import RowColTextField from "@/components/reusables/RowColTextField.vue";
import RowColRadioHorizontalField from "@/components/reusables/RowColRadioHorizontalField.vue";
import stay_data from "@/mixins/stay_data";
export default {
  mixins: [stay_data],
  components: { 
    DeleteReasonBtn,
    ColDateField,
    RowColTextAreaField,
    RowColSelectOneField,
    RowColTextField,
    RowColRadioHorizontalField
  },
  data() {
    return {
      forms: [
        {
          icon: "mdi-pencil",
          title: "stay.forms.modifyStay",
          path: "/forms/modifyStayForm"
        }
      ]
    };
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t("form.title"),
          value: "title[gl]"
        }
      ];
    }
  },

  created() {
    this.getStayWithBreadCrumb(
      this.$store.state.endpoint + "/stay/" + this.$route.params.id
    );
  }
};
</script>
